var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDarkMode = function SvgDarkMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M399.787 235.093c-7.68 27.307-11.52 55.893-11.52 84.907 0 174.08 141.653 315.733 315.733 315.733 29.013 0 57.6-3.84 84.907-11.52C744.534 733.44 637.014 810.666 512 810.666c-164.693 0-298.667-133.973-298.667-298.667 0-125.013 77.227-232.533 186.453-276.907zM512 128c-212.053 0-384 171.947-384 384s171.947 384 384 384 384-171.947 384-384c0-19.627-1.707-39.253-4.267-58.027C849.92 512.426 781.653 550.4 704 550.4c-127.147 0-230.4-103.253-230.4-230.4 0-77.227 37.973-145.92 96.427-187.733-18.773-2.56-38.4-4.267-58.027-4.267"
  })));
};
export default SvgDarkMode;